import { useMemo } from 'react';

export const usePortal = (containerId: string) => {
  return useMemo(() => {
    let el = document.getElementById(containerId);
    if (!el) {
      el = document.createElement('div');
      el.id = containerId;
      document.body.append(el);
    }
    return el;
  }, [containerId]);
};
